import { create } from 'zustand';

/**
 * F5.6 — Visit planner UI state.
 *
 * Holds only "which set of comuni is the dialog open for". Trip itself
 * (coords, duration, geometry, optimal order) is fetched on demand from
 * the OSRM public router and lives in TanStack Query.
 */

interface VisitPlannerState {
  /** istat codes the planner should route across; null = dialog closed. */
  openFor: string[] | null;
  open: (istats: string[]) => void;
  close: () => void;
}

export const useVisitPlannerStore = create<VisitPlannerState>((set) => ({
  openFor: null,
  open: (istats) => set({ openFor: istats }),
  close: () => set({ openFor: null }),
}));
